import { formatIls } from "@onecpa/shared";

/**
 * Money, rendered the way an accountant reads it.
 *
 * Three things this component exists to guarantee, none of which survive being
 * left to each call site:
 *
 *  - `<bdi>` isolation, so a shekel figure inside Hebrew prose cannot reorder
 *    against adjacent punctuation
 *  - tabular figures, so columns of numbers align
 *  - red ink and parentheses for negatives, and only for negatives
 */
export interface MoneyProps {
  /** Amount in agorot. Integers all the way to the render boundary. */
  agorot: number;
  decimals?: boolean;
  /** Tint losses red. On by default; turn off where red would be decorative. */
  colorize?: boolean;
  className?: string;
}

export function Money({ agorot, decimals = false, colorize = true, className = "" }: MoneyProps) {
  const isLoss = agorot < 0;
  const tone = colorize && isLoss ? "text-red-ink" : "";

  return (
    <bdi className={`tnum ${tone} ${className}`.trim()}>
      {formatIls(agorot / 100, { decimals })}
    </bdi>
  );
}
